var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.817,
    height: 21.995,
    viewBox: "0 0 20.817 21.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.771 0a1.044 1.044 0 0 0-1.044 1.044v7.31a1.044 1.044 0 1 0 2.089 0v-7.31A1.044 1.044 0 0 0 10.771 0zM7.254 2.855a1.045 1.045 0 0 0-1.414-.417 10.373 10.373 0 0 0-2.3 16.483A10.374 10.374 0 1 0 18.2 4.252a10.524 10.524 0 0 0-2.222-1.7 1.038 1.038 0 1 0-1.018 1.806 8.419 8.419 0 0 1 1.778 1.36 8.3 8.3 0 1 1-11.776-.04 8.25 8.25 0 0 1 1.884-1.411 1.036 1.036 0 0 0 .408-1.412z",
    transform: "translate(-.461)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconWhite);
export default __webpack_public_path__ + "static/media/logout-icon-white.531c1d8b20b2f709b8fa217a05112b14.svg";
export { ForwardRef as ReactComponent };